import React from 'react';
import { Link } from 'react-router-dom';
import './Button.css';

export default function Button({ variant = 'primary', to, className = 'uni-btn', children, ...props }) {
  const cls = `btn btn-${variant} ${className}`.trim();
  if (to) return <Link to={to} className={cls} {...props}>{children}</Link>;
  return (
    <button className={cls} {...props}>
      {children}
    </button>
  );
}
